type PromiseSettledResult<T> = { status: 'fulfilled'; value: T } | { status: 'rejected'; reason: any };

export async function pollyfilledAllSettled<T>(
  promises: Promise<T>[],
): Promise<PromiseSettledResult<T>[]> {
  return Promise.all(
    promises.map((p) => p
      .then((value) => ({
        status: 'fulfilled' as const,
        value,
      }))
      .catch((reason) => ({
        status: 'rejected' as const,
        reason,
      }))),
  );
}
